import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [selected, setSelected] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      setSelected('');
    }
  };

  return (
    <section id="categories" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[720px] mx-auto">
        <div className="text-center mb-5">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
            Browse by Category
          </h2>
          <p className="text-sm text-foreground-600">Select a category below to explore products on our main platform</p>
        </div>

        <div className="relative">
          <div className="relative">
            <select
              value={selected}
              onChange={handleChange}
              className="w-full appearance-none bg-background-100 border border-background-300 rounded-lg px-5 py-3.5 pr-12 text-sm font-medium text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all"
            >
              <option value="" disabled>-- Choose a Category --</option>
              {categories.map((cat) => (
                <option key={cat.slug} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
        </div>

        <p className="text-center text-xs text-foreground-500 mt-3">
          Selecting a category will open the corresponding page on our main platform in a new tab
        </p>
      </div>
    </section>
  );
}